import { HiCheckCircle, HiInformationCircle, HiExclamation, HiXCircle } from 'react-icons/hi'

const alerts = {
  success: {
    bgColor: 'bg-green-50',
    textColor: 'text-green-400',
    icon: HiCheckCircle
  },
  info: {
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-400',
    icon: HiInformationCircle
  },
  warning: {
    bgColor: 'bg-amber-50',
    textColor: 'text-amber-400',
    icon: HiExclamation
  },
  error: {
    bgColor: 'bg-red-50',
    textColor: 'text-red-400',
    icon: HiXCircle
  }
}

type AlertProps = {
  type?: 'success' | 'error' | 'warning' | 'info'
  title?: string
  message?: string
  error?: Error
  children?: JSX.Element[] | JSX.Element
}

export default function Alert(props: AlertProps) {
  const { type = 'info', title, message, error, children } = props

  const { bgColor, textColor } = alerts[type]
  const Icon = alerts[type].icon

  const renderContents = () => {
    if (children) {
      return children
    }
    return (
      <>
        {title && <h3 className="text-sm font-medium text-gray-900">{title}</h3>}
        {message && <p className="mt-2 text-sm text-gray-700">{message}</p>}

        {error && (
          <div className="overflow-x-auto">
            <p className="mt-2 text-sm text-gray-700">{error.message}</p>
            {/* <pre className="mt-2 text-sm text-gray-700">{error.stack}</pre> */}
          </div>
        )}
      </>
    )
  }

  return (
    <div className={`rounded-md ${bgColor} p-4 max-w-xl`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <Icon className={`h-5 w-5 ${textColor}`} aria-hidden="true" />
        </div>
        <div className="ml-3 overflow-hidden">{renderContents()}</div>
      </div>
    </div>
  )
}
